export default __webpack_public_path__ + "images/flags/ru.png?821948f6186371be0473d5e4ae087a2bae9b250b9ad63e82f4bedd904506c56d";